'use strict';
import {convertDataVToVue} from '../apply_vue_data_directives.js';
export class Gallery {
	Vue;
	constructor(component_id) {
		this.id = component_id;
		this.vars = yalwa.v.components[this.id];
		this.$root = jQuery(`.js-${this.id}`);
		this.$edit = this.$root.find(`.js-${this.id}_edit`);
		this.initalised = false;
	}
	init() {}
	vue_setup(Vue) {
		this.Vue = Vue;
		const ythis = this;

		if (!this.$root) {
			//console.error(`Vue JS container not found for ID: ${this.id}`);
			return {};
		}

		if (!window.__galleryStore) {
			window.__galleryStore = Vue.reactive({
				imagesFromBE: []
			});
		}

		const store = window.__galleryStore;

		let $rootx = document.querySelector(`.js-${this.id}`);
		const template = `${convertDataVToVue($rootx)}`;
		const backendData = yalwa.v.components[this.id].data;

		// init once
		if (!store.imagesFromBE.length) {
			store.imagesFromBE = structuredClone(backendData.images || []);
		}


		return ythis.Vue.defineComponent({
			delimiters: ['[[', ']]'],
			name: ythis.id,
			template,
			data(){
				return {
					store: store,
					maxImages : structuredClone(backendData.maxImages),
					sortableInstance : null,
					imageOrder : [],
					sliderBigImage : {image:'', image_name:0, index:0},
					sliderShow : false,
					isUploading: false,
					sliderCounter : 0
				}
			},
			setup() {},
			methods : {
				openSlider(image, index){
					//No Body scroll
					jQuery('html').addClass('js-no_scroll');
					this.sliderShow = true;
					const $slider = ythis.$root.find(jQuery(`.js-${ythis.id}_slider`));
					$slider.appendTo('body');
					this.selectSliderImage(image, index);
				},
				selectSliderImage(image, index){
					this.sliderBigImage = {image : image.image, image_name: image.image_name, index :index};
					this.sliderCounter = `${index+1}`;
				},
				prevImage(){
					let image = store.imagesFromBE[this.sliderBigImage.index - 1] ?? null;
					if (image) {
						this.selectSliderImage(image, this.sliderBigImage.index - 1)
					}
				},
				nextImage(){
					let image = store.imagesFromBE[this.sliderBigImage.index + 1] ?? null;
					if (image) {
						this.selectSliderImage(image, this.sliderBigImage.index + 1)
					}
				},
				sliderClose(){
					jQuery('html').removeClass('js-no_scroll');
					this.sliderShow = false;
				},
				saveGalleryImages() {
					if (!this.imageOrder) {
						return;
					}
					yalwa.basics.ajaxservice({
						type: 'POST',
						resource: 'profileupdate',
						action: 'update_gallery_image_order',
						data: {
							data : JSON.stringify(this.imageOrder),
						},
						include_session: true,
						is_cross_origin: false
					}).then(response => {
						if (response.type === 'success') {
							if (response.vip_completion) {
								document.dispatchEvent(new CustomEvent('vip_guide_state', {detail: response.vip_completion}));
							}
							//Todo check the issue with realtime sync
							store.imagesFromBE = structuredClone(response.images);
						}
						yalwa.basics.toast({message: response.label, type: response.type});
					});
				},
				deleteImage(data) {
					if (!data.image_name) {
						return;
					}
					yalwa.basics.ajaxservice({
						type: 'POST',
						resource: 'profileupdate',
						action: 'delete_gallery_image',
						data: {
							image_name : data.image_name,
						},
						include_session: true,
						is_cross_origin: false
					}).then(response => {
						if (response.type === 'success') {
							if (response.vip_completion) {
								document.dispatchEvent(new CustomEvent('vip_guide_state', {detail: response.vip_completion}));
							}
							store.imagesFromBE = structuredClone(response.images);
						}
						yalwa.basics.toast({message: response.label, type: response.type});
					});
				},
				openFileUpload(){
					this.initFileUpload();
					const fileInput = ythis.$root.find(jQuery(`.js-${ythis.id}_upload_init`));
					if (yalwa.v.is_ios) {
						fileInput[0].setAttribute('accept', 'image/*');
					}
					fileInput[0].click();
				},
				initFileUpload(){
					const fileInput = ythis.$root.find(jQuery(`.js-${ythis.id}_upload_init`));
					const dropZone = ythis.$root.find(jQuery(`.js-${ythis.id}_drop_zone`));

					fileInput.fileupload(jQuery.extend(yalwa.basics.upload_defaults(),{
						fileTypes: /(\.|\/)(gif|jpe?g|png)$/i,
						imageMaxWidth: 10000,
						imageMaxHeight: 10000,
						imageQuality: 1.0,
						dropZone: dropZone,
						url:'/api/ajax/user_gallery_image_upload',
						progressall: function (e, data) {
							let progress = parseInt(data.loaded / data.total * 100, 10);
						},
						send: (e, data) => {
							this.isUploading = true;
							return true;
						},
						fail: (e, data) => {
							this.isUploading = false;
						},
						done:  (e, data) => {
							this.isUploading = false;

							if (data.result.status) {
								store.imagesFromBE = structuredClone(data.result.images);
								if (data.result.vip_completion) {
									document.dispatchEvent(new CustomEvent('vip_guide_state', {detail: data.result.vip_completion}));
							}
						}

						yalwa.basics.toast({message: data.result.message, type: data.result.status});
					}
					}));
				},
				dragAndDrop() {
					const container = ythis.$root.find(jQuery(`.js-${ythis.id}_sorter`))[0];

					if (!container) return;

					// destroy old instance
					if (this.sortableInstance) {
						this.sortableInstance.destroy();
						this.sortableInstance = null;
					}

					this.sortableInstance = new Sortable(container, {
						filter: '.locked',
						preventOnFilter: false,
						animation: 200,
						ghostClass: 'drag-ghost',
						delay: 250,
						delayOnTouchOnly: true,
						touchStartThreshold: 5,
						onMove: (evt) => {
							if (!evt.related.dataset.id) {
								return false;
							}
						},

						onEnd: () => {
							const order = Array.from(container.children)
								.map(el => el.dataset.id);
							this.imageOrder = order;
							//Save realtime
							this.saveGalleryImages();
						}
					});
				},
				sliderImage(){
					let imageEL = document.getElementById("js-gallery_image_slider_drag");
					let startX = 0;
					let endX = 0;
					const handleGesture = () => {
						let direction = "";
						// Check if the movement was significant (e.g., more than 50px) to avoid accidental clicks
						if (Math.abs(endX - startX) > 50) {
							direction = (endX < startX) ? "left" : "right";
							switch (direction) {
								case 'left':
									this.nextImage();
									break;
								case 'right':
									this.prevImage();

							}
						}
					}
					imageEL.addEventListener('mousedown', e => {
						startX = e.pageX;
					});
					imageEL.addEventListener('mouseup', e => {
						endX = e.pageX;
						handleGesture();
					});
					imageEL.addEventListener('touchstart', e => {
						startX = e.changedTouches[0].screenX;
					});

					imageEL.addEventListener('touchend', e => {
						endX = e.changedTouches[0].screenX;
						handleGesture();
					});
				}
			},
			computed: {
				totalImagesLeftToUpload() {
					return this.maxImages - this.store.imagesFromBE.length;
				},
				totalImagesForPlaceHolder() {
					if (this.store.imagesFromBE.length < 5) {
						return 5 - this.store.imagesFromBE.length;
					}
					return 0;
				},
				sliderCounterLabel() {
					return '(' + this.sliderCounter + '/' + this.store.imagesFromBE.length + ')';
				},
				isUnchanged() {
					return this.imageOrder.length
				}
			},
			updated() {
				this.initFileUpload();
			},
			watch: {
				imagesFromBE() {
					//this.dragAndDrop();
				}
			},
			mounted() {
				this.sliderImage();
				yalwa.basics.load_js(yalwa.v.js_path + 'external/fileupload.js', () => {
					this.initFileUpload();
				});

				yalwa.basics.load_js(yalwa.basics.static_url('js') + 'external/sortable.min.js', () => {
					this.dragAndDrop();
				});

				// The picker click is bound once per document instead of per
				// component instance: WebKit only, accept="image/*" filters the
				// camera to photo-only mode (no video toggle - the app has no video
				// permission and would crash) and hides video in the library picker.
				jQuery(document).off('click.gallery_upload', '.js-' + ythis.id + '_drop_zone').on('click.gallery_upload', '.js-' + ythis.id + '_drop_zone', function (event) {
					const gallery = jQuery(this).closest('.js-' + ythis.id);
					const fileInput = gallery.find('.js-' + ythis.id + '_upload_init');
					if (!fileInput.length) {
						return;
					}
					// In the android app the shared upload menu owns this click
					if (yalwa.v.is_phonegap && !yalwa.v.is_ios) {
						return;
					}
					if (yalwa.v.is_ios) {
						fileInput[0].setAttribute('accept', 'image/*');
					}
					fileInput[0].click();
				});

				jQuery(document).on('keydown', (event) => {
					if (!this.sliderShow) {
						return;
					}
					if (event.which === 37) {
						event.preventDefault();
						this.prevImage();
					} else if (event.which === 39) {
						event.preventDefault();
						this.nextImage();
					}
				});
			},
		});
	}
	setup_vars(Vue) {
		this.images = Vue.ref('');
		this.sliderBigImage = Vue.ref('');
		this.sliderCounter = Vue.ref('');
		this.sliderShow = Vue.ref('');
	}
}
